module.exports = __webpack_public_path__ + "img/progress_080.7f3084de.png";